import React, { Component } from 'react';
import styled from 'styled-components';
import Header from '../../components/Header';
import TasterSubscriptionCMS from './components/TasterSubscriptionCMS';
import TasterSubscriptionList from './components/TasterSubscriptionList';
import Card from '../../components/Card';
import Button from '../../components/Button';
import {
  getUserJournals,
  patchUserJournals,
  postUserJournals,
  deleteUserJournals
} from '../../actions/journals';

import { connect } from 'react-redux';

import Spinner from '../../components/Spinner';
import history from '../../history';
import { I18n } from 'react-redux-i18n';
import { useUserMe } from '../../apiTyped/hooks/users.query';

const TasterSubscriptionContainer = styled.div`
  flex: 1;

  .cardContainer {
    margin-top: 16px;
    margin-bottom: 37px;
  }

  .actionButtonsContainer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .tsPageListContainer {
    width: calc(99vw - 230px);
    overflow-x: auto;
  }

  .saveButtonScrolled {
    z-index: 9999;
    position: fixed;
    top: 20px;
    right: 80px;
  }

  .linkBack {
    font-size: 20px;
    width: 32px;
  }

  .linkBack:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;

class TasterSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [], loading: true };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps !== this.props &&
      prevProps.journals !== this.props.journals
    ) {
      let { journals } = this.props;
      journals = journals.map((journal) =>
        journal.data ? { ...journal, original: journal.data } : journal
      );
      this.setState({ data: journals });
    }
  }

  async componentDidMount() {
    await this.props.getUserJournals();
    this.setState({ loading: false });
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  sortColumn(key) {
    let { data, sortAscending } = this.state;
    data.sort(function (a, b) {
      return String(a[key]).localeCompare(String(b[key]));
    });

    if (sortAscending) {
      this.setState({ data, sortAscending: !sortAscending });
    } else {
      this.setState({
        data: data.reverse(),
        sortAscending: !sortAscending
      });
    }
  }

  handleSelectChange(id, value) {
    let { data } = this.state;
    data = data.map((item) => {
      if (item.id === id) {
        item.data = { ...item.data, subscription_type: value.value };
        item.status = item.status != 'created' ? 'modified' : 'created';
      }
      return item;
    });
    this.setState({ data });
  }

  handleCheckbox(id) {
    let { data } = this.state;
    data = data.map((item) => {
      if (item.id === id) {
        if (item.data) {
          delete item.data;
          item.status = 'removed';
        } else {
          item = {
            ...item,
            status: 'created',
            data: {
              journal: item.id,
              login: null,
              subscription_type:
                item.subscription_types && item.subscription_types.length > 0
                  ? item.subscription_types[0].id
                  : null,
              client: this.props.user.client.id
            }
          };
        }
      }
      return item;
    });
    this.setState({ data });
  }

  handleLogin(id, value) {
    let { data } = this.state;
    data = data.map((item) => {
      if (item.id === id) {
        item.data = { ...item.data, login: value };
        item.status = item.status != 'created' ? 'modified' : 'created';
      }
      return item;
    });
    this.setState({ data });
  }

  async handleSubmit() {
    const { data } = this.state;
    this.setState({ loading: true });
    for (let journal of data) {
      if (journal.status === 'removed' && journal.original) {
        await this.props.deleteUserJournals(journal.original.id);
      }

      if (
        journal.status === 'created' &&
        !journal.original &&
        journal.data.subscription_type
      ) {
        await this.props.postUserJournals(journal.data);
      }

      if (
        journal.status === 'modified' &&
        JSON.stringify(journal.orignal) !== JSON.stringify(journal.data)
      ) {
        await this.props.patchUserJournals(journal.data);
      }
    }
    //minimum loading to be seen (otherwise too fast)
    setTimeout(() => this.setState({ loading: false }), 500);
  }

  handleScroll(props) {
    this.setState({
      scrolled:
        props && props.path && props.path[1]
          ? props.path[1].pageYOffset > 300
          : false
    });
  }

  removeDoubles(data) {
    const names = [];
    return data.filter((item) => {
      if (!names.includes(item.name)) {
        names.push(item.name);
        return true;
      }
      return false;
    });
  }

  render() {
    let { data, scrolled } = this.state;
    data = this.removeDoubles(data);
    return (
      <TasterSubscriptionContainer>
        <Header
          title={I18n.t('tasterSubscription.title')}
          subTitle={I18n.t('tasterSubscription.subTitle')}
        />
        <Card className="cardContainer">
          <div className="linkBack" onClick={() => history.goBack()}>
            <Button
              type="round"
              icon="arrowFullLeft"
              iconColor="#e25d34"
              color="white"
            />
          </div>
          <TasterSubscriptionCMS />
          <div className="actionButtonsContainer">
            <div className={scrolled && 'saveButtonScrolled'}>
              <Button
                label={I18n.t('tasterSubscription.save')}
                onClick={() => this.handleSubmit()}
                textTransform="normal"
              />
            </div>
          </div>
          <div className="tsPageListContainer">
            <TasterSubscriptionList
              sortColumn={(columnName) => this.sortColumn(columnName)}
              handleCheckbox={(id) => this.handleCheckbox(id)}
              handleSelectChange={(id, value) =>
                this.handleSelectChange(id, value)
              }
              handleLogin={(id, value) => this.handleLogin(id, value)}
              data={data}
            />
          </div>
        </Card>

        <Spinner loading={this.state.loading} />
      </TasterSubscriptionContainer>
    );
  }
}

const Index = (props) => {
  const { user } = useUserMe();
  return <TasterSubscription {...props} user={user} />;
};

const mapStateToProps = (state) => {
  return {
    journals: state.journals
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserJournals: async () => {
      await dispatch(getUserJournals());
    },
    postUserJournals: async (data) => {
      await dispatch(postUserJournals(data));
    },
    patchUserJournals: async (data) => {
      await dispatch(patchUserJournals(data));
    },
    deleteUserJournals: async (id) => {
      await dispatch(deleteUserJournals(id));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
